export enum TemperatureUnit {
    C, F
}